module.exports = __webpack_public_path__ + "img/offers.25182af8.svg";